import { render, staticRenderFns } from "./PromotionDappRewardItem.vue?vue&type=template&id=744ae1a2&scoped=true&"
import script from "./PromotionDappRewardItem.vue?vue&type=script&lang=js&"
export * from "./PromotionDappRewardItem.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDappRewardItem.vue?vue&type=style&index=0&id=744ae1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744ae1a2",
  null
  
)

export default component.exports